import React from 'react'
import { FormCheckInput } from 'src/components/forms/FormCheckInput'
import { FormLabel } from 'src/components/forms/FormLabel'
import { CCol, CRow } from '@coreui/react-pro'
import { FormTextInput } from 'src/components/forms/FormTextInput'
import { useFormikContext } from 'formik'
import { FormSelect } from 'src/components/forms/selects/FormSelect'
import { SearchableSelect } from 'src/components/forms/selects/SearchableSelect'
import { FormTextarea } from 'src/components/forms/FormTextarea'

export default function CreateFormSilkRoadConfiguration({ readOnly = false, mfPartners = [], t }) {
  const { values } = useFormikContext()

  const partnerOptions = mfPartners?.map((partner) => {
    return { label: partner.name, value: partner.id }
  })

  return (
    <div>
      <SearchableSelect
        name="name"
        label={t('Backoffice.MfErpIntegration.table.columns.partnerName')}
        placeholder={t('Backoffice.MfErpIntegration.table.columns.partnerName')}
        id="partner_name"
        options={partnerOptions}
        disabled={readOnly}
      />
      <FormSelect
        className="my-2 form-control-backoffice"
        placeholder={t('Backoffice.MfSilkRoadConfiguration.table.columns.deliveryMethod')}
        name="delivery_method"
        label={t('Backoffice.MfSilkRoadConfiguration.table.columns.deliveryMethod')}
        id="delivery_method"
        options={[
          { value: 'mail', label: 'mail' },
          { value: 'sftp', label: 'sftp' },
          { value: 'as2', label: 'as2' },
        ]}
        disabled={readOnly}
      />

      {values.delivery_method === 'mail' && (
        <div>
          <FormTextInput
            className="my-2 form-control-backoffice"
            name="email"
            label={'Email'}
            placeholder={'Email'}
            id="email"
            type="text"
            disabled={readOnly}
          />
          <FormSelect
            className="my-2 form-control-backoffice"
            placeholder={t('Header.Navigation.Label.Language')}
            name="language"
            label={t('Header.Navigation.Label.Language')}
            id="language"
            options={[
              { value: 'de', label: t('Global.Language.German') },
              { value: 'fr', label: t('Global.Language.French') },
              { value: 'it', label: t('Global.Language.Italian') },
              { value: 'en', label: t('Global.Language.English') },
            ]}
            disabled={readOnly}
          />
          <FormTextInput
            className="my-2 form-control-backoffice"
            name="bcc"
            label={'BCC'}
            placeholder={'BCC'}
            id="bcc"
            type="text"
            disabled={readOnly}
          />
        </div>
      )}
      {values.delivery_method === 'sftp' && (
        <div>
          <FormTextInput
            className="my-2 form-control-backoffice"
            name="gln"
            label={'GLN'}
            placeholder={'GLN'}
            id="gln"
            type="text"
            disabled={readOnly}
          />
          <FormTextInput
            className="my-2 form-control-backoffice"
            name="sftp_url"
            label={'SFTP URL'}
            placeholder={'SFTP URL'}
            id="sftp_url"
            type="text"
            disabled={readOnly}
          />
          <FormTextInput
            className="my-2 form-control-backoffice"
            name="sftp_username"
            label={'SFTP Username'}
            placeholder={'SFTP Username'}
            id="sftp_username"
            type="text"
            disabled={readOnly}
          />
          <FormTextarea
            className="my-2 form-control-backoffice"
            name="sftp_password"
            id="sftp_password"
            label={'SFTP Key'}
            placeholder={'SFTP Key'}
            disabled={readOnly}
          ></FormTextarea>
          <FormTextInput
            className="my-2 form-control-backoffice"
            name="sftp_path"
            label={'SFTP Path'}
            placeholder={'SFTP Path'}
            id="sftp_path"
            type="text"
            disabled={readOnly}
          />
        </div>
      )}
      {values.delivery_method === 'as2' && (
        <div>
          <FormTextInput
            className="my-2 form-control-backoffice"
            name="gln"
            label={'GLN'}
            placeholder={'GLN'}
            id="gln"
            type="text"
            disabled={readOnly}
          />
          <FormTextInput
            className="my-2 form-control-backoffice"
            name="connector_id"
            label={'Connector ID'}
            placeholder={'Connector ID'}
            id="connector_id"
            type="text"
            disabled={readOnly}
          />
        </div>
      )}
      <CCol md="12">
        <CRow>
          <FormLabel name="Status" />
        </CRow>
        <CRow>
          <CCol md="4">
            <FormCheckInput
              label="active"
              value="active"
              type="radio"
              id="status"
              name="status"
              disabled={readOnly}
            />
          </CCol>
          <CCol md="4">
            <FormCheckInput
              label="inactive"
              value="inactive"
              type="radio"
              id="status"
              name="status"
              disabled={readOnly}
            />
          </CCol>
        </CRow>
      </CCol>
    </div>
  )
}
